export default __webpack_public_path__ + "static/media/scooter-prodcutos-2-mb@2x.90642b86.jpg";